module.exports = __webpack_public_path__ + "img/home.747b7f03.png";